import {
  doc,
  updateDoc,
  arrayUnion,
  getDoc,
  setDoc,
  arrayRemove,
} from "firebase/firestore";
import { db } from "./firebase";
import { PrintQueue } from "@/app/@types/printer";

/**
 * Queue a print job by adding ZPL to the user's print queue
 */
export const queuePrintJob = async (userId: string, zpl: string) => {
  const printQueueRef = doc(db, `users/${userId}/metadata/printQueue`);

  // Check if document exists first
  const docSnap = await getDoc(printQueueRef);

  if (!docSnap.exists()) {
    // Create the document with initial queue
    await setDoc(printQueueRef, {
      all: [zpl],
    } as PrintQueue);
  } else {
    // Add to existing queue
    await updateDoc(printQueueRef, {
      all: arrayUnion(zpl),
    });
  }
};

/**
 * Queue multiple print jobs at once
 */
export const queuePrintJobs = async (userId: string, zplArray: string[]) => {
  const printQueueRef = doc(db, `users/${userId}/metadata/printQueue`);

  // Check if document exists first
  const docSnap = await getDoc(printQueueRef);

  if (!docSnap.exists()) {
    // Create the document with initial queue
    await setDoc(printQueueRef, {
      all: zplArray,
    } as PrintQueue);
  } else {
    // Add to existing queue using arrayUnion
    await updateDoc(printQueueRef, {
      all: arrayUnion(...zplArray),
    });
  }
};

/**
 * Remove a ZPL string from the print queue after processing
 */
export const removePrintJob = async (userId: string, zpl: string) => {
  const printQueueRef = doc(db, `users/${userId}/metadata/printQueue`);

  await updateDoc(printQueueRef, {
    all: arrayRemove(zpl),
  });
};
